export const styles = (theme) => ({
  root: {
    zIndex: 999,
    marginTop: theme.spacing(6),
    [theme.breakpoints.down('sm')]: {
      marginTop: theme.spacing(3),
    },
  },

  title: {
    color: '#fff',
    marginBottom: theme.spacing(1),
    fontWeight: 'bold',
    zIndex: 999,
    textShadow: '0px 4px 4px rgba(0, 0, 0, 0.05)',
    textAlign: 'center',
  },

  description: {
    color: '#fff',
    zIndex: 999,
    fontWeight: 500,
    textShadow: '0px 4px 4px rgba(0, 0, 0, 0.05)',
    textAlign: 'center',
  },

  secondDescription: {
    color: '#fff',
    fontWeight: 500,
    zIndex: 999,
    textShadow:
      '0 1px 1px 0 rgba(0,0,0,0), 0 2px 1px -1px rgba(0,0,0,0.0), 0 1px 3px 0 rgba(0,0,0,0.05)',
    marginTop: 8,
    textAlign: 'center',
  },
})
